import React from "react";
import PropTypes from "prop-types";

import { Help } from "rbx";
import { VERSION } from "../config";

const Copyright = ({ color, align }) => (
  <Help align={align} color={color}>
    TGMS ™ V{VERSION} <br />
    {new Date().getFullYear()} © GraVoc Associates, Inc.
  </Help>
);

Copyright.propTypes = {
  color: PropTypes.string,
  align: PropTypes.string
};

Copyright.defaultProps = {
  color: "white",
  align: "center"
};
export default Copyright;
